import { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, useParams, useLocation } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
import * as userActions from "../../actions/userActions";
import * as leadActions from "../../actions/leadActions";
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import '../common.scss';

import AccessDenied from '../common/AccessDenied';
// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------
const SubDealerCreatePage = (props) => {
  const { id } = useParams();
  const location = useLocation();
  const { actions, usersData, roleInfo } = props;
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const navigate = useNavigate();
  const [allUsers, setAllUsers] = useState([]);
  const [roleId, setRoleId] = useState('');
  const [showRoleDetails, setShowRoleDetails] = useState(false);

  const [addModulePermissionStatus, setAddModulePermissionStatus] = useState(false);
  const [editModulePermissionStatus, setEditModulePermissionStatus] = useState(false);
  const [userHasPermission, setUserHasPermission] = useState(true);
  const [permissions, setPermissions] = useState([]);
  const [allRoleType, setAllRoleType] = useState([]);
  const [allDealers, setAllDealers] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState(null);


  useEffect(() => {
    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.getUserModuleData(requestData);
    response.then((result) => {
      // console.log("Promise resolved -  getUserModuleData:", result);
      if (result.data.success === 1) {
        const permissionsData = result.data.data;
        setPermissions(permissionsData);
        const leadPermissions = permissionsData.find(permission => permission.module_name === 'Sub Dealer');
        const hasAddPermissions = leadPermissions?.add_permission;
        const hasEditPermissions = leadPermissions?.edit_permission;

        setAddModulePermissionStatus(hasAddPermissions);
        setEditModulePermissionStatus(hasEditPermissions);
        setUserHasPermission(id !== undefined ? hasEditPermissions : hasAddPermissions);
      }
    }).catch((error) => {
      console.error("Promise rejected -  lead list:", error);
    });
  }, [setPermissions, setUserHasPermission]);

  useEffect(() => {
    // check user is logged-in or not
    const authToken = localStorage.getItem('authToken');
    if (authToken === null) {
      navigate('/login');
    }

    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    actions.usersData(requestData);
    if (usersData.success) {
      setAllUsers(usersData.data);
    }
  }, []);

  useEffect(() => { 
     const objMasters = { 'start': '0', 'length': config.MAX_RECORDS , module: 'lead_details'};
      const requestDataMasters = encryptData(objMasters);
      const responseMasters = actions.masterAllData(requestDataMasters, false);
      responseMasters.then((result) => {
          // console.log("Promise resolved -  master profile data:", result); 

            if (result.data.success === 1) {
              const results = result.data.data;
              const dealerArrData = results?.all_dealers || [];
              setAllDealers(dealerArrData); 

          }
      }).catch((error) => {
          // console.log("000000000000000000000 error  = ",error)
      });


  }, [setAllRoleType, setAllDealers ]);


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setShowRoleDetails(false);

    if (id !== undefined && !showRoleDetails) { 
      const decodedId = atob(id);
      setRoleId(decodedId);
      const obj = { 'start': '0', 'length': config.MAX_RECORDS, 'id': decodedId };
      const requestData = encryptData(obj);
      const response = actions.masterSubDealersData(requestData);
      response.then((result) => {
          // console.log("Promise resolved -  masterSubDealersData:", result);
          if (result.data.success === 1) {
              setShowRoleDetails(true);
              const results = result.data.data;
              setValue("name", results.data[0].name);
              setValue("dealer_id", results.data[0].dealer_id);
              setValue("status", results.data[0].status);

              handleDealerVal({ target: { value: results.data[0].dealer_id } });
              setSelectedDealer(results.data[0].dealer_id);
          }
      }).catch((error) => {
          // console.error("Promise rejected -  masterSubDealersData:", error);
      });
    }
  }, [id, setValue, setShowRoleDetails]);

  const handleDealerVal = (event) => {
    const selectedDealer = event.target.value;
    setSelectedDealer(selectedDealer);
  }

  const onSubmit = (data) => {
    let params = { 'name': data.name, 'status': data.status, "dealer_id": selectedDealer };

    if (roleId !== '') {
      params = { 'name': data.name, 'status': data.status, "dealer_id": selectedDealer, 'id': roleId };
    }
    const requestData = encryptData(params);
    const response = actions.addEditSubDealerData(requestData);
    response.then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result); 
        if (result.data.success === 1) {
            toast.success(result.data.message, {
                position: "top-right",
            });
            setTimeout(() => {
              navigate('/dashboard/sub-dealers');
            }, 1000);
        } else {
            toast.error(result.data.message, {
                position: "top-right",
            });
        }
    }).catch((error) => {
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
            position: "top-right",
        });
    });
  };

  if (!userHasPermission) {
    // Redirect or render an access denied message
    return <AccessDenied />;
  }

  return (
    <>
      <Helmet>
        <title> Create Sub Dealer | Ckers </title>
      </Helmet>

      <Container>
        <Typography variant="h4" sx={{ mb: 5 }}>
          {showRoleDetails ? "Edit Sub Dealer" : "Create Sub Dealer"}
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div id='main-wrap'>
            <div className='row'>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label htmlFor="name">
                    <span>Sub Dealer <a style={{ color: "red" }}>*</a></span>
                    <input type='text' name='name' className='form-control'
                      {...register('name', { required: true })} />
                  </label>
                  {errors.name && <span className="required">This field is required.</span>}
                </div>
              </div>

              <div className='col-md-6'>
                <div className='form-group'>
                  <label htmlFor="role-type">
                    <span>Dealer <a style={{ color: "red" }}>*</a></span>
                    <select 
                      name='dealer_id'
                      className="form-select"
                      {...register('dealer_id', { required: true })}
                      value={selectedDealer}
                      onChange={handleDealerVal}
                    >
                      <option value="">Select Dealer</option>
                      {allDealers && allDealers.map((option) => (
                        <option value={option.id}>
                         {option.name}
                        </option>
                      ))}
                    </select>
                  </label>
                  {errors.dealer_id && <span className="required">This field is required.</span>}
                </div>
              </div>

              <div className='col-md-6'>
                <div className='form-group'>
                  <label htmlFor="reporting-user">
                    <span>Status <a style={{ color: "red" }}>*</a></span>
                    <select name='status' className="form-select" {...register('status', { required: true })}>
                      <option value="">Select Status</option>
                      <option value="1">Active</option>
                      <option value="2">Inactive</option>
                    </select>
                  </label>
                  {errors.status && <span className="required">This field is required.</span>}
                </div>
              </div>
              <div className='col-md-12'>
                <div className='form-group mb-2'>
                  <button className='btn btn-primary'>Submit</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Container>
    </>
  );
}

function mapStateToProps(state) {
  return {
    usersData: state.usersData,
    roleInfo: state.roleInfo,
    getUserModuleData: state.getUserModuleData,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(userActions.default,leadActions.default), dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(SubDealerCreatePage);